import React from "react";

export function ClipPathRect({ id, x, y, width, height }) {
  return (
    <defs>
      <clipPath id={id}>
        <rect x={x} y={y} width={width} height={height} />
      </clipPath>
    </defs>
  );
}

export function BackgroundRect({ x, y, width, height, fill }) {
  if (!fill || fill === "transparent") return null;
  return <rect x={x} y={y} width={width} height={height} fill={fill} />;
}

export function GridVertical({ xs, top, bottom, color, dash, strokeWidth }) {
  if (!xs || xs.length === 0) return null;
  return (
    <>
      {xs.map((x, i) => (
        <line
          key={i}
          x1={x}
          x2={x}
          y1={top}
          y2={bottom}
          stroke={color}
          strokeWidth={strokeWidth || 1}
          strokeDasharray={dash}
        />
      ))}
    </>
  );
}

export function GridHorizontal({ ys, left, right, color, dash, strokeWidth }) {
  if (!ys || ys.length === 0) return null;
  return (
    <>
      {ys.map((y, i) => (
        <line
          key={i}
          x1={left}
          x2={right}
          y1={y}
          y2={y}
          stroke={color}
          strokeWidth={strokeWidth || 1}
          strokeDasharray={dash}
        />
      ))}
    </>
  );
}

export function AxisLines({ xAxis, yAxis, color }) {
  return (
    <>
      {xAxis && (
        <line
          x1={xAxis.x1}
          x2={xAxis.x2}
          y1={xAxis.y}
          y2={xAxis.y}
          stroke={color}
        />
      )}
      {yAxis && (
        <line
          x1={yAxis.x}
          x2={yAxis.x}
          y1={yAxis.y1}
          y2={yAxis.y2}
          stroke={color}
        />
      )}
    </>
  );
}
